import { useCallback, useState } from "react";
import GridResultadoExamen from "../Components/ResultadoExamen/GridResultadoExamen";
import PanelFiltrosResultados from "../Components/ResultadoExamen/PanelFiltrosResultados";
import { usePageSubtitulo } from "../context/PageHeaderContext";

// SISTEMA-DE-DISENO · patrón LISTADO.
// Las migas de pan salen: el título de la pantalla vive en la barra superior
// (`utils/tituloPagina.js`), y el conteo del filtro activo lo publica esta
// pantalla como subtítulo, que es la única que lo sabe.
//
// La lógica no cambia: `filters` sigue siendo el mismo objeto, se sigue
// pasando igual a <GridResultadoExamen>, y la carga inicial automática se
// conserva (al montar, `filters` = {} y el grid consulta la página 1).
function ResultadoExamen() {
    // RESULTADOS-04-FILTROS-PERFORMANCE-01: el panel de filtros es
    // permanentemente visible (antes era un Offcanvas que habia que abrir).
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(null);

    const handleBuscar = (nuevosFiltros) => {
        setFilters(nuevosFiltros);
    };

    const handleLimpiar = () => {
        setFilters({});
    };

    // `useCallback` a propósito: el grid lo recibe dentro de `data` y una
    // función nueva en cada render volvería a disparar su efecto de carga.
    const handleTotal = useCallback((n) => setTotal(n), []);

    usePageSubtitulo(total === null ? "" : `${total} resultado${total === 1 ? "" : "s"}`);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <PanelFiltrosResultados onBuscar={handleBuscar} onLimpiar={handleLimpiar} />

                <GridResultadoExamen data={{ filters, onTotal: handleTotal }} />
            </div>
        </div>
    );
}

export default ResultadoExamen;
